import { render, staticRenderFns } from "./PDVMesas.vue?vue&type=template&id=3b550850&scoped=true&"
import script from "./PDVMesas.vue?vue&type=script&lang=js&"
export * from "./PDVMesas.vue?vue&type=script&lang=js&"
import style0 from "./PDVMesas.vue?vue&type=style&index=0&id=3b550850&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b550850",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
